import React, { forwardRef } from 'react'
import * as styles from '../styles/components/content-wrapper.module.scss'
import cx from 'classnames'
import { motion } from 'framer-motion'
import ColorFill, { FillColor } from './color-fill'

export type ContentWrapperProps = Omit<React.HTMLProps<HTMLDivElement>, 'style'> & {
    color?: FillColor
}

const ContentWrapper = forwardRef<HTMLDivElement, ContentWrapperProps>((props, ref) => {
    const { children, color = 'white', className, ...rest } = props
    return (
        <ColorFill color={color} className={cx(styles.container, className)} ref={ref} {...rest}>
            {children}
        </ColorFill>
    )
})

export default motion(ContentWrapper)
